import React, {Component} from 'react';
import '@ant-design/compatible/assets/index.css';
import {Modal, Input, Form, InputNumber, Radio} from 'antd';
import {postLevel} from "../../../lib/api_levels";


const Level4AddModal = ({visible, onOk, onCancel,p}) => {
    const [form] = Form.useForm();

    const handleOk = (e) => {
        e.preventDefault();

        form.validateFields()
            .then(values => {
                console.log(values)
                postLevel({
                    pid: p.id,
                    level: p.level+1,
                    name: values.name,
                    code: values.code,
                    order_index: values.order_index,
                    time_weight: values.time_weight,
                    rootid: p.rootid,
                    sld_total: values.sld_total,
                })
                    .then(res => {
                        if (res.code === 0) {
                            onOk && onOk();
                        }
                    });
            });

    };
    const handleCancel = () => {
        onCancel && onCancel();
    };
    return (
        <Modal
            title="添加知识要点"
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            destroyOnClose={true}>
            <Form form={form} labelCol={{span: 6}}>
                <Form.Item
                    label="编号"
                    name="code"
                    rules={[
                        {
                            required: true,
                            message: '请输入编号',
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="名称"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: '请输入名称',
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="时间权重"
                    name="time_weight"
                    rules={[
                        {
                            required: true,
                            message: '请输入时间权重',
                        },
                    ]}
                >
                    <InputNumber/>
                </Form.Item>
                <Form.Item
                    label="掌握熟练度"
                    name="sld_total"
                    rules={[
                        {
                            required: true,
                            message: '请输入掌握熟练度',
                        },
                    ]}
                >
                    <InputNumber/>
                </Form.Item>
                <Form.Item
                    label="排序"
                    name="order_index"
                    rules={[
                        {
                            required: true,
                            message: '请输入排序',
                        },
                    ]}
                >
                    <InputNumber/>
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default Level4AddModal;
